const FONTS = {
    PRIMARY_FONT: 'Inter',
    SECONDARY_FONT: 'Roboto',
    TERTIARY_FONT: 'Poppins'
};

export default FONTS;
